module.exports = __webpack_public_path__ + "img/CB[1]-CC-1.f59c9019.gif";